import { useMemo } from 'react';
import { useCampaignEditorContext } from 'sections/onsite-campaigns/pages/CampaignEditor/contexts/CampaignEditorContext';

export const useGetDrawer = () => {
  const { state } = useCampaignEditorContext();

  return useMemo(() => state.drawer, [state.drawer]);
};
